import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Help(props) {
  var cssClass = classNames('tds-form__help', props.classNames, {
    'tds-form__help--emphasised': props.emphasised,
    'tds-form__help--segment': props.isSegment,
    'tds-form__help--alternative': props.alternative,
    'tds-form__help--alt-icon': props.altIcon
  }, props.theme);
  return props.children ? /*#__PURE__*/React.createElement("div", {
    className: cssClass
  }, props.children) : /*#__PURE__*/React.createElement("span", null);
}

Help.propTypes = {
  classNames: PropTypes.string,
  emphasised: PropTypes.bool,
  isSegment: PropTypes.bool,
  alternative: PropTypes.bool,
  children: PropTypes.node,
  theme: PropTypes.string,
  altIcon: PropTypes.bool
};
Help.defaultProps = {
  emphasised: false,
  isSegment: false,
  alternative: false,
  classNames: '',
  children: null,
  theme: 'burning-orange',
  altIcon: false
};
export default Help;